import { Input } from 'reactstrap';
import PropTypes from 'prop-types';
import { getItem, STORAGE_KEYS } from '../../../services/storage';

const MetodosPago = ({ metodosPago, setRecibos, isLoading, actual, numRecibo, disabled }) => {
  const user = getItem(STORAGE_KEYS.USER);

  const handleOnChange = (e) => {
    setRecibos((prev) =>
      prev.map((recibo) => {
        if (recibo.NUM_Recibo === numRecibo) {
          return { ...recibo, idPago: Number(e.target.value) };
        }
        return recibo;
      }),
    );
  };

  return (
    <>
      {isLoading || metodosPago.length === 0 ? (
        ''
      ) : (
        <Input
          type="select"
          name={numRecibo}
          id={numRecibo}
          onChange={handleOnChange}
          value={actual}
          style={{
            width: '150px',
            height: '30px',
            fontSize: '13px',
            padding: '5px',
            color: disabled ? '#6c757d' : 'inherit',
          }}
          disabled={user.profileObj.email === 'ajimenez@cedetecgroup.com' || disabled}
        >
          {metodosPago.map((datos) => (
            <option key={datos.id} value={datos.id}>
              {datos.descripcion}
            </option>
          ))}
        </Input>
      )}
    </>
  );
};
MetodosPago.propTypes = {
  metodosPago: PropTypes.array,
  setRecibos: PropTypes.func,
  isLoading: PropTypes.bool,
  actual: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  numRecibo: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  disabled: PropTypes.bool,
};
export default MetodosPago;
